import { useEffect } from 'react';
import { isImageFile, isVideoFile } from '../utils/media';

interface ImageHandlerProps {
    onAddImage: (file: File) => void;
    onError: (message: string) => void;
}

const useImagePaste = ({ onAddImage, onError }: ImageHandlerProps) => {
    useEffect(() => {
        const handlePaste = (event: ClipboardEvent) => {
            if (!event.clipboardData) return;

            // Вставка в редактор описания обрабатывается TipTap
            const target = event.target as HTMLElement | null;
            if (target?.closest?.('.ProseMirror, .tiptap, .task-editor')) {
                return;
            }

            const files = event.clipboardData.files;
            if (files.length === 0) return;

            const file = files[0];

            if (isVideoFile(file) || isImageFile(file) || file.type.startsWith('image/')) {
                onAddImage(file);
                return;
            }

            onError('Неподдерживаемый тип файла. Нужно изображение или видео (MP4, WEBM, MOV).');
        };

        // @ts-ignore
        window.addEventListener('paste', handlePaste);

        return () => {
            // @ts-ignore
            window.removeEventListener('paste', handlePaste);
        };
    }, [onAddImage, onError]);
};

export default useImagePaste;
